import * as React from "react";
function TransportTaxiTypeStandardElectric() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 160 160"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "usbms9m9cndak2a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,120 H 120 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "usbms9m9cndak3b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.45218,45.0803 H 110.129 V 26.6535 H 8.45218 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usbms9m9cndak2a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 160)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usbms9m9cndak3b)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.149,-5.019 -23.031,-8.411 -51.108,-7.576 -28.077,0.834 -50.716,5.579 -50.567,10.598 0.149,5.019 23.031,8.411 51.107,7.576 C -22.491,9.764 0.149,5.019 0,0",
    transform: "translate(110.128 34.356)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5b5b5b",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,10.06 -8.155,18.216 -18.216,18.216 -10.06,0 -18.215,-8.156 -18.215,-18.216 0,-10.06 8.155,-18.216 18.215,-18.216 C -8.155,-18.216 0,-10.06 0,0",
    transform: "translate(112.249 75.13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-0.787 8.048,18.696 8.048,18.696 l -13.164,0.296 c 0,0 8.758,14.853 8.758,16.164 h 6.822 L 2.175,23.373 14.776,22.368 Z",
    transform: "translate(88.932 53.696)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -2.175,-0.941 -5.585,-2.116 -6.29,-4.762 -0.706,-2.645 -0.892,-9.089 0.347,-10.217 l 7.413,-0.188 z",
    transform: "translate(16.128 55.638)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -2.175,-0.941 -7.878,-5.761 -8.583,-8.407 -0.705,-2.645 -0.892,-9.088 0.348,-10.217 l 6.824,-0.364 z",
    transform: "translate(62.864 54.756)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0.295,-0.649 2.065,-3.54 4.189,-4.189 2.123,-0.648 5.781,-0.294 7.197,0.59 1.415,0.885 2.654,1.593 3.598,4.012 0.944,2.419 2.301,7.905 -0.944,10.501 C 10.796,13.509 2.832,14.925 2.006,13.981 1.18,13.037 0,0 0,0",
    transform: "translate(92.834 37.739)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -1.06,-0.608 -2.238,-1.119 -3.187,-2.95 -0.949,-1.831 -1.424,-5.187 -1.356,-6.713 0.067,-1.526 0.576,-4.543 1.864,-6.578 1.289,-2.034 2.408,-2.984 4.035,-3.221 1.628,-0.237 5.72,0.104 6.432,0.274 0.712,0.169 1.695,0.78 2.17,1.356 0.474,0.577 1.525,1.729 2.102,4.374 0.576,2.645 0.715,7.059 -2.065,11.976 C 8.549,1.074 2.306,1.322 0,0",
    transform: "translate(59.478 50.961)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-2.521 -0.919,-4.557 -2.053,-4.548 -1.134,0.01 -2.054,2.061 -2.054,4.582 0,2.521 0.92,4.557 2.054,4.548 C -0.919,4.572 0,2.521 0,0",
    transform: "translate(62.255 41.511)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.923,-0.529 -1.947,-0.973 -2.773,-2.566 -0.826,-1.593 -1.239,-4.513 -1.18,-5.841 0.059,-1.327 0.502,-3.952 1.623,-5.722 1.121,-1.77 2.094,-2.596 3.51,-2.802 1.416,-0.206 4.336,0 4.955,0.147 0.62,0.148 1.475,0.679 1.888,1.18 0.413,0.502 1.327,1.505 1.829,3.805 0.501,2.301 0.826,6.136 -1.593,10.413 C 7.001,0.837 2.006,1.15 0,0",
    transform: "translate(14.255 52.37)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0.871,6.595 4.38,6.034 7.491,7.403 2.608,1.147 5.627,4.389 10.354,6.302 9.707,3.929 28.917,2.605 41.316,2.125 9.412,-0.365 21.944,-9.54 25.247,-12.746 0.025,-0.025 0.047,-0.036 0.083,-0.041 0.14,-0.021 0.691,-0.147 2.683,-0.883 1.684,-0.622 4.979,-1.745 5.4,-1.784 0.42,-0.038 1.393,0 3.209,-0.859 6.753,-3.198 6.249,-10.055 6.043,-15.033 0.077,-0.421 0.18,-1.362 0.153,-1.722 -0.09,-1.213 -7.431,-2.938 -17.649,-3.286 -1.855,-0.063 -16.381,0.001 -21.565,0.068 -1.164,0.016 -2.148,0.823 -2.42,1.955 -0.744,3.095 -1.294,7.9 -2.012,10.111 -2.149,6.62 -10.953,4.852 -11.619,-2.568 -0.428,-4.77 0.183,-6.727 0.734,-8.623 -7.838,0.399 -25.319,1.712 -33.513,2.691 -0.601,0.071 -1.734,0.762 -1.963,1.909 -1.002,4.754 0.947,11.428 -4.803,12.212 -5.832,-0.667 -5.886,-8.245 -4.824,-12.713 -0.112,0 -0.383,0.316 -0.769,0.55 -0.963,0.581 -1.616,1.994 -1.939,3.072 -0.468,1.559 -0.607,3.389 -0.515,4.851 0.018,0.296 0.113,0.571 0.211,0.851 C -0.074,-4.457 -0.037,-0.839 0,0",
    transform: "translate(8.656 55.46)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -1.921,0.886 -0.964,1.946 -0.375,2.42 1.704,1.372 5.37,4.415 10.935,5.333 3.984,0.657 9.18,0.501 12.787,-2.368 3.904,-3.106 7.96,-7.786 8.421,-8.609 C 30.034,-3.477 4.932,-2.274 0,0",
    transform: "translate(21.93 61.638)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,0 4.533,-2.864 8.379,-6.477 2.691,-2.528 5.511,-4.921 5.871,-5.137 0.359,-0.215 13.94,-0.808 17.611,-0.733 5.766,0.116 11.939,0.482 14.145,0.56 0.16,0.005 -6.376,4.501 -10.919,7.267 -4.875,2.967 -5.579,2.669 -9.46,3.459 -3.881,0.791 -9.022,1.005 -14.628,1.005 C 8.913,-0.056 0,0 0,0",
    transform: "translate(44.205 70.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474646",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -3.881,0.791 -9.022,1.005 -14.628,1.005 -0.173,0 -0.406,0 -0.664,0.001 1.449,-1.084 3.139,-2.436 4.718,-3.919 2.691,-2.528 5.511,-4.921 5.871,-5.137 0.359,-0.216 13.94,-0.808 17.611,-0.734 1.514,0.031 3.055,0.079 4.546,0.134 -2.269,1.543 -5.445,3.639 -7.995,5.191 C 4.585,-0.492 3.881,-0.791 0,0",
    transform: "translate(63.158 66.687)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5aaad",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 1.033,-3.025 4.833,-5.756 5.326,-5.881 1.43,-0.362 5.686,-0.839 7.914,-0.624 0.788,0.077 3.094,0.305 3.449,0.66 C 14.843,-4.897 8.903,-2.007 2.947,-0.503 0.743,0.053 0,0 0,0",
    transform: "translate(67.888 55.197)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a5aaad",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0.561,-0.468 1.282,-0.726 1.999,-1.963 0.707,-1.219 0.709,-2.68 1.154,-2.965 0.444,-0.285 2.007,-0.091 2.369,0.03 0.768,0.255 0.401,0.956 0.401,0.956 0,0 -0.688,1.696 -1.879,2.518 C 3.289,-0.903 0.461,0.042 0,0",
    transform: "translate(101.567 54.328)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c 0,-2.306 -0.738,-4.175 -1.648,-4.175 -0.91,0 -1.648,1.869 -1.648,4.175 0,2.306 0.738,4.175 1.648,4.175 C -0.738,4.175 0,2.306 0,0",
    transform: "translate(15.94 44.105)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.422,-0.654 -0.829,-1.139 -2.066,-3.825 -2.055,-4.465 -2.098,-7.169 -2.098,-7.169 l 3.456,-0.467 c 0,0 0.478,2.714 0.928,4.214 0.451,1.501 1.86,5.603 3.21,7.242 z",
    transform: "translate(35.172 70.23)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4f4f4f",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 c -0.364,0.084 -0.802,-0.065 -0.818,-0.49 -0.018,-0.472 -0.02,-1.241 -0.018,-1.449 2.192,-0.292 7.098,-0.527 10.63,-0.298 5.514,0.358 9.721,1.517 9.721,1.517 0,0 -0.068,0.545 -0.179,1.253 C 19.317,0.87 19.07,1.059 18.667,1.009 17.622,0.879 14.249,0.302 10.734,-0.114 5.997,-0.675 1.508,-0.089 0,0",
    transform: "translate(88.098 42.208)"
  })));
}
export default TransportTaxiTypeStandardElectric;